import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import Main from "../components/Main";
import Article from "../components/Main/Article";
import PageHeader from "../components/Page/PageHeader";
import Content from "../components/Main/Content";
import Grid from "@material-ui/core/Grid";
import {
  Badge,
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardImg,
  CardBody,
  CardFooter,
  Button
} from "shards-react";
import codegem from "../images/projects/codegem.png";
import agilite from "../images/projects/agilite.png";
import angeleth from "../images/projects/angeleth.png";
import glassbox from "../images/projects/glassbox.png";
import transupport from "../images/projects/transupport.png";
const styles = theme => ({
  card: {
    display: "flex"
  },
  details: {
    display: "flex",
    flexDirection: "column"
  },
  content: {
    flex: "1 0 auto"
  },
  cover: {
    width: 151
  },
  controls: {
    display: "flex",
    alignItems: "center"
  },
  playIcon: {
    height: 38,
    width: 38
  }
});
const Project = props => {
  return (
    <Main>
      <Article>
        <PageHeader title="Projects" />
        <Content>
          <Container>
            <Grid container spacing={3}>
              {projects.map(project => {
                return (
                  <Grid item xs={6}>
                    <Card style={{ margin: "20px", marginBottom: "60px" }}>
                      <CardImg
                        src={project.img}
                        style={{
                          width: "100%",
                          boxShadow: "0 3px 6px rgba(0,0,0,0.15)",
                          borderRadius: "15px 15px 0px 0px"
                        }}
                      />
                      <CardBody style={{ height: "fit-content" }}>
                        <Button
                          href={project.link}
                          target="_blank"
                          size="sm"
                          pill
                          theme="info"
                          style={{
                            color: "white",
                            textDecoration: "none",
                            fontSize: "10px",
                            display: "inline-block",
                            float: "right",
                            marginTop: -3,
                            marginRight: 3
                          }}
                        >
                          View Github Repo
                        </Button>
                        <CardTitle>{project.name}</CardTitle>

                        <p>{project.description}</p>
                        {project.tech.map(tech => (
                          <Badge
                            style={{ marginLeft: "6px", marginRight: "6px" }}
                            outline
                            pill
                            theme="info"
                          >
                            {tech}
                          </Badge>
                        ))}
                      </CardBody>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </Container>
        </Content>
      </Article>
    </Main>
  );
};

Project.propTypes = {
  classes: PropTypes.object.isRequired
};

export default injectSheet(styles)(Project);

const projects = [
  {
    name: "CodeGem",
    description:
      "Web App designed to help software teams fully leverage Github's pull request review process by quantifying code improvements, enhancing and sharing developer learnings, and promoting quality PR reviews",
    tech: ["Probot", "Node", "PostgreSQL", "React"],
    img: codegem,
    link: "https://github.com/StephanieJoyMills/code-gem"
  },
  {
    name: "Agilite",
    description:
      "Application that uses machine learning to digitalize agile board. Board can then be edited, shared, and exported",
    tech: ["Python", "PostgreSQL", "Knex", "Node"],
    img: agilite,
    link: "https://github.com/StephanieJoyMills/Agilite"
  },
  {
    name: "GlassBox",
    description: "Inventory management system built for donation driven charities",
    tech: ["Node", "PostgreSQL", "PostgREST"],
    img: glassbox,
    link: "https://github.com/VaniDevs/AxiomZen"
  },
  {
    name: "Transupport",
    description: "DSS used to optimize transportation selection for product distribution",
    tech: ["Python", "Flask", "Swagger"],
    img: transupport,
    link: "https://github.com/StephanieJoyMills/transupport"
  },
  {
    name: "AngelEth",
    description: "Micro-investment blockchain application ",
    tech: ["Node", "Web3.js", "Solidity"],
    img: angeleth,
    link: "https://github.com/theRoughCode/ethstarter"
  }
];



// WEBPACK FOOTER //
// ./src/pages/projects.js